import { COUNTRY_OPTIONS } from 'constants/delivery'
import { isInvalidPlace } from 'utils/validators/googlePlace'

export function parseFavouritePayload(payload) {
  return {
    ...payload,
    merchandise: payload.merchandise.map(({ quantity, ...merchandise }) => ({
      ...merchandise,
      width: parseInt(merchandise.width),
      height: parseInt(merchandise.height),
      depth: parseInt(merchandise.depth),
      weight: parseFloat(merchandise.weight),
      ...(merchandise.type !== 'bulk' ? { quantity: parseInt(quantity) } : {}),
    })),
    options: Object.keys(payload.options || {}).filter((key) => payload.options[key] === true),
    transportRules: Object.keys(payload.transportRules || {}).filter((key) => payload.transportRules[key] === true),
    freightForwarders: payload.freightForwarders.map((item) => item.value),
    pickupWaypoints: payload.pickupWaypoints?.map(({ googlePlaceId, ...waypoint }) => ({
      ...waypoint,
      googlePlaceId: !isInvalidPlace(googlePlaceId) ? googlePlaceId : undefined,
    })),
    receiptWaypoints: payload.receiptWaypoints?.map(({ googlePlaceId, ...waypoint }) => ({
      ...waypoint,
      googlePlaceId: !isInvalidPlace(googlePlaceId) ? googlePlaceId : undefined,
    })),
  }
}

export function parseCountry(countryName) {
  if (!countryName) {
    return { value: 'fr', label: 'FRA' }
  }
  const selectedCountry = COUNTRY_OPTIONS.find((country) => country.name === countryName)
  return selectedCountry
}

export function decorateFavouriteEntity(entity) {
  return {
    ...entity,
    options: entity.options.reduce((previous, key) => ({ ...previous, [key]: true }), {}),
    transportRules: entity.transportRules.reduce((previous, key) => ({ ...previous, [key]: true }), {}),
    ...(entity.freightForwarders && {
      freightForwarders: entity.freightForwarders.map((item) => ({
        label: `${item.firstname} ${item.lastname} - ${item.managedCompany ? item.managedCompany.name : ''}`,
        value: item['@id'],
      })),
    }),
    receiptWaypoints: entity.receiptWaypoints.map((entity) => ({
      additionalAddress: entity.additionalAddress,
      address: entity.address,
      country: parseCountry(entity.country),
      googlePlaceId: entity.googlePlaceId,
    })),
    pickupWaypoints: entity.pickupWaypoints.map((entity) => ({
      additionalAddress: entity.additionalAddress,
      address: entity.address,
      country: parseCountry(entity.country),
      googlePlaceId: entity.googlePlaceId,
    })),
  }
}
